var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.037,
    height: 19.889,
    viewBox: "0 0 10.037 19.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    transform: "translate(-1026.37 497.889) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_83",
    "data-name": "Line 83",
    d: "M8.444,8.537a1.494,1.494,0,0,1-.959-.348L-.96,1.152A1.5,1.5,0,0,1-1.152-.96,1.5,1.5,0,0,1,.96-1.152L9.4,5.885a1.5,1.5,0,0,1-.961,2.652Z",
    transform: "translate(479.5 1027.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_84",
    "data-name": "Line 84",
    d: "M0,8.537A1.5,1.5,0,0,1-1.152,8,1.5,1.5,0,0,1-.96,5.885L7.484-1.152A1.5,1.5,0,0,1,9.6-.96,1.5,1.5,0,0,1,9.4,1.152L.96,8.189A1.494,1.494,0,0,1,0,8.537Z",
    transform: "translate(487.944 1027.87)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a40a56be7a452f2d13098d6d7ae33ea1.svg";
export { ForwardRef as ReactComponent };